import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-configurator-shadow-field',
  templateUrl: './shadow-field.component.html'
})
export class ShadowFieldComponent {
  @Input() label: String = '';
  @Input() initialX: Number = 0;
  @Input() initialY: Number = 0;
  @Input() initialB: Number = 0;
  @Input() initialS: Number = 0;
  @Input() colorOpacity: Number = 10;

  constructor() {}
}
